import React, { FC } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import styles from './GeneralWellnessComponent.module.scss';
import boddVariables from '../../../variables.module.scss';
import getColourForDialGroup, { getLabelForDialGroup } from '../../../services/DialGroupService';
import { WellnessItem } from '../../../services/DataFormatService';

interface GeneralWellnessComponentProps {
    wellnessScoreItem: WellnessItem,
}

const GeneralWellnessComponent: FC<GeneralWellnessComponentProps> = (props) => {
    const { wellnessScoreItem } = props;
    return (
        <Stack className={styles.GeneralWellnessComponent} data-testid="GeneralWellnessComponent">
            <Typography sx={{
                fontFamily: 'Poppins',
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '30px',
                color: boddVariables.black,
                textAlign: 'left',
            }}
            >
                General Wellness
            </Typography>
            <Box sx={{
                py: 3,
                pl: 3,
                pr: 2.25,
                borderRadius: '7px',
                border: `2px solid ${boddVariables.grey50}`,
            }}
            >
                <Stack direction="row" justifyContent="space-between">
                    <Stack direction="row">
                        <Box
                            bgcolor={getColourForDialGroup(wellnessScoreItem.dialGroup!)}
                            sx={{
                                borderRadius: '50%',
                                width: '14px',
                                height: '14px',
                                mr: 2,
                                mt: 0.75,
                            }}
                        />
                        <Typography sx={{
                            fontFamily: 'Poppins',
                            fontWeight: '400',
                            fontSize: '28px',
                            lineHeight: '28px',
                            color: boddVariables.black,
                        }}
                        >
                            {getLabelForDialGroup(wellnessScoreItem.dialGroup!)}
                        </Typography>
                    </Stack>
                    <Stack direction="row" spacing={0.5}>
                        <Typography sx={{
                            fontFamily: 'Poppins',
                            fontWeight: '600',
                            fontSize: '28px',
                            lineHeight: '28px',
                            color: boddVariables.black,
                            textAlign: 'right',
                        }}
                        >
                            {wellnessScoreItem.formattedValue}
                        </Typography>
                        <Typography sx={{
                            fontFamily: 'Poppins',
                            fontWeight: '400',
                            fontSize: '12px',
                            lineHeight: '20px',
                            color: boddVariables.black,
                            textAlign: 'right',
                        }}
                        >
                            /100
                        </Typography>
                    </Stack>
                </Stack>
            </Box>
        </Stack>
    );
};

export default GeneralWellnessComponent;
